import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { useEffect } from 'react';
import { PENDING_INVITE_REDIRECT_KEY } from 'pages/auth/GuestInvitationRedirect/GuestInvitationRedirect';
import { AppProvider } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { NAVIGATION } from '../DashboardPage/navigation';
import logo from 'assets/new/textLogo.png';
import SidebarLogout from 'components/buttons/SidebarLogout/SidebarLogout';
import { Header } from 'components/common/Header/Header';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import SidebarHeader from 'components/common/SidebarHeader/SidebarHeader';
import SidebarFooter from 'components/common/SidebarFooter/SidebarFooter';
import ChatWidget from 'components/common/ChatWidget/ChatWidget';

export default function MainPage() {
  const location = useLocation();
  const navigateRR = useNavigate();
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // After login: consume any pending redirect stored by GuestInvitationRedirect
  useEffect(() => {
    const raw = localStorage.getItem(PENDING_INVITE_REDIRECT_KEY);
    if (!raw) return;
    try {
      const { path, state } = JSON.parse(raw);
      localStorage.removeItem(PENDING_INVITE_REDIRECT_KEY);
      navigateRR(path, { replace: true, state });
    } catch {
      localStorage.removeItem(PENDING_INVITE_REDIRECT_KEY);
    }
  }, [navigateRR]);

  const goHome = () => {
    navigateRR('/dashboard')
  }

  return (
    <AppProvider
      navigation={NAVIGATION}
      router={{
        pathname: location.pathname,
        searchParams,
        navigate: (url) => {
          navigateRR(typeof url === 'string' ? url : url.pathname);
        },
      }}
      branding={{
        logo: (
          <img
            src={logo}
            alt="Casez"
            style={{ height: 32 }}
            onClick={goHome}
          />
        ),
        title: ''
      }}
      theme={theme}
    >
      <DashboardLayout
        slots={{
          toolbarActions: isMobile ? undefined : Header,
          sidebarFooter: SidebarFooter,
        }}
        sx={{
          '& a:hover, & button:hover': {
            color: 'inherit',
          },
        }}>
        <Outlet />
        {/* <ChatWidget /> */}
      </DashboardLayout>
    </AppProvider>
  );
}
